/**
 * Offering Context Types
 *
 * These types define the structure of the JSONB context field in the offerings table.
 * The schema_version field allows for future schema migrations.
 */
export const PRICING_PRESETS = [
    {
        label: "Monthly Subscription",
        model: "subscription",
        unit: "month",
        defaultCurrency: "USD",
    },
    {
        label: "One-time Purchase",
        model: "one-time",
        unit: "lifetime",
        defaultCurrency: "USD",
    },
    {
        label: "Usage-based Pricing",
        model: "usage",
        unit: "per use",
        defaultCurrency: "USD",
    },
];
/**
 * Type guard to check if context is v1
 */
export function isOfferingContextV1(context) {
    return context && context.schema_version === "v1";
}
/**
 * Default empty offering context
 */
export function createDefaultOfferingContext() {
    return {
        schema_version: "v1",
        name: "",
        type: "product",
        physical: false,
        features: [],
        differentiators: [],
        pain_points: [],
        benefits: [],
    };
}
/**
 * Create a pricing tier from a preset
 */
export function createPricingTierFromPreset(preset, amount = 0, tier) {
    return {
        tier,
        model: preset.model,
        amount,
        currency: preset.defaultCurrency,
        unit: preset.unit,
    };
}
